import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";

export interface IConfirmPayoutRuleDateData {
  title: string;
  question: string;
}

/** Asks the admin to read back the date a payout rule version will take effect before it is saved. */
@Component({
  selector: 'app-confirm-payout-rule-date',
  standalone: true,
  imports: [DialogBaseComponent, MatButton],
  templateUrl: './confirm-payout-rule-date.component.html'
})
export class ConfirmPayoutRuleDateDialogComponent {
  private dialogRef = inject(MatDialogRef<ConfirmPayoutRuleDateDialogComponent>);
  public data: IConfirmPayoutRuleDateData = inject(MAT_DIALOG_DATA);

  confirm(): void {
    this.dialogRef.close(true);
  }
}
